var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6665 12.3337H15.6665V2.33366C15.6665 1.89163 15.4909 1.46771 15.1783 1.15515C14.8658 0.842587 14.4419 0.666992 13.9998 0.666992C13.5578 0.666992 13.1339 0.842587 12.8213 1.15515C12.5088 1.46771 12.3332 1.89163 12.3332 2.33366V12.3337H2.33317C1.89114 12.3337 1.46722 12.5093 1.15466 12.8218C0.842099 13.1344 0.666504 13.5583 0.666504 14.0003C0.666504 14.4424 0.842099 14.8663 1.15466 15.1788C1.46722 15.4914 1.89114 15.667 2.33317 15.667H12.3332V25.667C12.3332 26.109 12.5088 26.5329 12.8213 26.8455C13.1339 27.1581 13.5578 27.3337 13.9998 27.3337C14.4419 27.3337 14.8658 27.1581 15.1783 26.8455C15.4909 26.5329 15.6665 26.109 15.6665 25.667V15.667H25.6665C26.1085 15.667 26.5325 15.4914 26.845 15.1788C27.1576 14.8663 27.3332 14.4424 27.3332 14.0003C27.3332 13.5583 27.1576 13.1344 26.845 12.8218C26.5325 12.5093 26.1085 12.3337 25.6665 12.3337Z",
    fill: "#FE7474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBig);
export default __webpack_public_path__ + "static/media/icon-plus-big.26035815a2b68743b8655b735e4bfd64.svg";
export { ForwardRef as ReactComponent };